import { theme } from "@tm/utility/global";
import styled from "styled-components";
const breakpoints = {
  lg: "992px",
};

export const TravelFormWrapper = styled.div<{ $isFederated?: boolean }>`
  width: 1200px;
  margin: ${({ $isFederated }) =>
    $isFederated ? "0px auto 0px auto" : "60px auto 0px auto"};
  background-size: 100%;
  overflow: visible;

  @media (max-width: 767px) {
    html:not([data-device="tablet"]) & {
      width: 100%;
      min-width: 320px;
      overflow-x: auto;
    }
  }
`;

export const LabelWithIcon = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 6px;
`;

export const TravelFormContainer = styled.div<{ $isFederated?: boolean }>`
  padding: ${({ $isFederated }) =>
    $isFederated ? "65px 16px 16px 16px" : "55px 16px 16px 16px"};
  background: ${theme.whiteText};
  border-radius: 8px;
  font-family: sans-serif;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  align-self: center;
`;

export const FormHeader = styled.div``;

export const ProductBanner = styled.div<{ isRevamp: boolean }>`
  display: flex;
  background: radial-gradient(
    75.36% 140.35% at 100% 0%,
    #ead4ff 0%,
    #ffffff 100%
  );
  align-items: center;
  font-size: 0.9rem;
  height: 42px;
  ${(props) =>
    props.isRevamp &&
    `padding: 5px 12px;
     border-radius: 8px;
     margin-bottom: 8px;`}
  ${(props) =>
    !props.isRevamp &&
    `
  padding-right: 40px; 
  border-top-right-radius: 45px;
  `}
`;

export const FormHeaderFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const PersuasionText = styled.h1`
  font-size: 18px;
  color: ${theme.greyText};
  padding: 0px 12px;
  text-align: right;
  font-weight: 700;
  font-size: 16px;
`;

export const BannerIcon = styled.div<{ isRevamp: boolean }>`
  margin-right: 4px;
  width: 24px;
  height: 20px;
  ${(isRevamp) => (isRevamp ? `margin-left: 0px;` : `margin-left: 16px;`)}
`;

export const TrailingBannerIcon = styled.div`
  margin-left: 4px;
  height: 16px;
  cursor: pointer;
`;

export const BannerContent = styled.div<{ isRevamp: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  white-space: nowrap;
  ${(isRevamp) => (isRevamp ? `font-size: 12px;` : `font-size: 14px;`)}
`;

export const BannerInfo = styled.div`
  margin-left: 6px;
`;

export const FormContent = styled.div`
  display: flex;
  align-items: flex-start;
  border: 1px solid ${theme.darkGreyBg};
  border-radius: 10px;
`;

export const FormSection = styled.div`
  padding: 8px 16px 12px 16px;
  position: relative;
  overflow: visible;

  &:nth-of-type(1) {
    flex: 0.5;
  }

  &:nth-of-type(3) {
    flex: 0.25;
  }
  &:nth-of-type(5) {
    flex: 0.25;
  }

  &:not(:last-child)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 1px;
  }
`;

export const Label = styled.p`
  color: ${theme.greyText};
  margin-bottom: 4px;
  margin-top: 8px;
  font-size: 14px;
  font-weight: 900;
`;

export const Badge = styled.div<{ bgColor: string[] }>`
  background: ${({ bgColor }) =>
    bgColor.length > 1
      ? `linear-gradient(to right, ${bgColor.join(", ")})`
      : bgColor[0] || "#53B2FE"};
  color: ${theme.whiteText};
  font-weight: 900;
  font-size: 14px;
  border-radius: 5px;
  padding: 2px 10px;
  display: inline-block;
  margin-top: 8px;
  letter-spacing: 1px;
  text-align: center;
  width: fit-content;
  line-height: 20px;
`;

export const MainText = styled.p`
  font-size: 1.25rem;
  font-weight: bold;
  display: flex;
  align-items: baseline;
`;

export const DateNumber = styled.span`
  font-family: Lato;
  font-weight: 700;
  font-size: 32px;
  line-height: 100%;
  letter-spacing: 0px;
`;

export const DateMonthYear = styled.span`
  font-family: Lato;
  font-weight: 400;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-left: 4px;
`;

export const CalendarDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 9999;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  margin-top: 8px;
  width: 600px;
  overflow: visible;
  transform: translateY(0);

  &:before {
    content: "";
    position: absolute;
    top: -8px;
    left: 20px;
    width: 16px;
    height: 16px;
    background-color: white;
    transform: rotate(45deg);
    box-shadow: -2px -2px 5px rgba(0, 0, 0, 0.06);
  }

  /* Style DayPicker to match your design */
  .rdp {
    margin: 0;
    padding: 16px;
  }

  .rdp-month {
    margin: 0 8px;
  }

  .rdp-day_selected {
    background-color: var(--tm-accent-color);
  }

  .rdp-day_range_middle {
    background-color: #e5efff;
  }

  .rdp-day_range_end,
  .rdp-day_range_start {
    background-color: var(--tm-accent-color);
  }
`;

export const TravellerNumber = styled.span`
  font-size: 32px;
  font-weight: 700;
  line-height: 100%;
  font-family: Lato;
  letter-spacing: 0px;
`;

export const TravellerText = styled.span`
  font-family: Lato;
  font-weight: 400;
  font-size: 22px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-left: 4px;
`;

export const TravellerDropdown = styled.div`
  position: absolute;
  z-index: 10;
  background: ${theme.whiteText};
  width: 100%;
  left: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  top: 100%;
  max-height: 240px;
  overflow-y: auto;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
`;

export const NumberItem = styled.div<{ isSelected: boolean }>`
  padding: 12px 16px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
  font-weight: ${({ isSelected }) => (isSelected ? "700" : "400")};
  color: ${({ isSelected }) => (isSelected ? "#008CFF" : "#333")};
  background-color: ${({ isSelected }) =>
    isSelected ? "#f5f9ff" : "transparent"};

  &:hover {
    background-color: #f9f9f9;
  }
`;

export const Divider = styled.div`
  align-self: stretch;
  width: 1px;
  background-color: #e0e0e0;
`;

export const SubText = styled.p`
  font-size: 14px;
  color: ${theme.greyText};
  margin-bottom: 2px;
`;

export const ArrowIcon = styled.img<{ isRotated?: boolean }>`
  width: 9px;
  height: 9px;

  @media (min-width: ${breakpoints.lg}) {
    width: 9px;
    height: 9px;
  }
  margin-left: 4px;
  transform: ${(props) =>
    props.isRotated ? "rotate(180deg)" : "rotate(0deg)"};
  transition: transform 0.3s ease-in-out;
`;

export const SegmentWrapper = styled.div`
  margin-top: 28px;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const LabelWrapper = styled.div`
  flex: 0 0 auto;
  ${Label} {
    white-space: nowrap;
    margin: 0;
  }
`;

export const SegmentHeader = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 900;
  color: ${({ selected }) => (selected ? theme.blueText : theme.greyText)};
`;

export const SegmentFlexContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  width: auto;
`;

export const SegmentMainContainer = styled.div`
  flex: 1;
`;

export const SegmentContainer = styled.div`
  flex: 1;
`;

export const SegmentOptions = styled.div`
  display: flex;
  gap: 8px;
  flex: 1;
`;

export const SegmentButton = styled.span<{ selected: boolean }>`
  border: 1px solid ${({ selected }) => (selected ? " #008CFF" : "#ccc")};
  background-color: ${({ selected }) => (selected ? "#EAF5FF" : "#fff")};
  border-radius: 8px;
  padding: 4px 8px;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;

  ${SegmentHeader} p {
    font-weight: ${({ selected }) => (selected ? "500" : "normal")};
    color: ${({ selected }) => (selected ? theme.blueText : theme.greyText)};
  }

  ${SubText} {
    color: ${theme.greyText6};
  }
`;

export const SegmentTag = styled.div<{ startColor: string; endColor: string }>`
  position: absolute;
  top: -12px;
  left: 10px;
  min-width: 40px;
  background: ${({ startColor, endColor }) =>
    `linear-gradient(to right, ${startColor}, ${endColor})`};
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CTAWrapper = styled.div`
  margin-top: 2rem;
  text-align: center;

  button {
    border-radius: 38px;
  }
`;

export const CheckboxContainer = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  margin-right: 8px;
  margin-top: 4px;
`;

export const Checkbox = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;
export const CalendarDropdownWrap = styled.div`
  width: 592px;
  background: ${theme.whiteText};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  z-index: 1;
  border-radius: 4px;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 0;
  top: 30px;

  .calenderHeader {
    margin-top: 0;
  }
  .rdp-cell {
    width: 38px;
    height: 38px;
  }

  .rdp-cell:hover {
    border-radius: 0;
  }

  .rdp-weeknumber,
  .rdp-day {
    font-size: 12px;
    width: 38px;
    height: 38px;
  }

  .rdp-day_selected,
  .rdp-day_selected:focus-visible {
    background: #eaf5ff;
    color: ${theme.blackText};
    border-radius: 0;
  }

  .rdp-day_range_start,
  .rdp-day_range_end {
    background: ${theme.blueText};
    border-radius: 0px 2px 2px 0px;
    color: ${theme.whiteText};
  }
  .rdp-head_cell {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: ${theme.greyText4};
  }
  .rdp-caption_label {
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: ${theme.blackText};
  }
  .rdp-caption_label .boldText {
    font-weight: 700;
  }
  /* .rdp-button[disabled]:not(.rdp-day_selected) {
        opacity: 1;
    } */
  .rdp-day_today {
    font-weight: 400;
  }
  .rdp-button svg {
    display: none;
  }
  .rdp-button:hover:not([disabled]):not(.rdp-day_selected) {
    background: ${theme.lightBlueBg};
    border-radius: 0;
  }
  .rdp-nav_button_previous:before,
  .rdp-nav_button_next:before {
    position: absolute;
    top: 20px;
    content: "";
    width: 20px;
    height: 2px;
    background: ${theme.blueText};
    border-radius: 2px;
    background-image: none;
  }
  .rdp-nav_button_previous:after {
    left: 7px;
    transform: rotate(-45deg);
  }
  .rdp-nav_button_next:after {
    right: 7px;
    transform: rotate(135deg);
  }
  .rdp-nav_button_previous:after,
  .rdp-nav_button_next:after {
    position: absolute;
    top: 17px;
    content: "";
    width: 8px;
    height: 8px;
    background-image: none;
    border-top: solid 2px ${theme.blueText};
    border-left: solid 2px ${theme.blueText};
  }

  /* Single date mode styling to match range mode */
  &.single-date-mode .rdp-day_selected,
  &.single-date-mode .rdp-day_selected:focus-visible {
    background: ${theme.blueText} !important;
    color: #fff !important;
    border-radius: 2px;
  }
`;
export const ErrorToast = styled.div`
  border-radius: 6px;
  background: ${theme.lightRed};
  padding: 12px 16px;
  margin: 0 16px 16px;
  width: auto;
  color: #d32f2f;
`;

export const CheckboxLabel = styled.label`
  position: relative;
  cursor: pointer;
  height: 20px;
  width: 20px;
  background-color: white;
  border: 2px solid #ccc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:after {
    content: "";
    position: absolute;
    display: none;
    width: 10px;
    height: 10px;
    background-color: ${theme.blueText};
    border-radius: 50%;
  }

  ${Checkbox}:checked + && {
    border-color: ${theme.blueText};
  }

  ${Checkbox}:checked + &&:after {
    display: block;
  }
`;

export const SegmentContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 4px;
`;

export const ErrorSpan = styled.span`
  color: #e53e3e;
  font-size: 14px;
  margin-top: 4px;
  display: block;
`;

export const DatePickerHeader = styled.div`
  padding: 8px;
  background-color: ${theme.whiteText};
`;

export const DatePickerHeaderInner = styled.div`
  padding: 8px;
  border-radius: 4px;
  background-color: ${theme.lightBlueBg};
`;

export const RadioItem = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 8px;
  font-size: 14px;

  ${(props) =>
    props.isSelected
      ? `
  background: ${theme.lightBlueBg};
  border-radius: 16px;
  font-weight: 900;
  `
      : `
  background: ${theme.whiteText};
  font-weight: 400;
  `}
`;

export const TripOptionsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const IconContainer = styled.div`
  width: 16px;
  height: 16px;
`;
